import React from "react";
import { cn } from "../../lib/utils";

export function KpiCard({ label, value, hint, accent = false, onClick, testId, icon: Icon }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={cn(
        "obsidian obsidian-hover relative text-left w-full p-5",
        "transition-all duration-200",
        onClick ? "cursor-pointer" : "cursor-default",
        "btn-tactile",
      )}
    >
      <div className="flex items-start justify-between">
        <div className="text-[11px] font-medium text-muted-foreground uppercase tracking-[0.16em]">
          {label}
        </div>
        {Icon && (
          <div
            data-testid={`${testId || "kpi-card"}-icon-surface`}
            className="w-8 h-8 rounded-xl border border-brand/25 bg-brand/10 flex items-center justify-center text-brand"
          >
            <Icon className="w-3.5 h-3.5" />
          </div>
        )}
      </div>
      <div
        className={cn(
          "mt-3 text-[34px] leading-none font-display font-semibold tabular-nums",
          accent ? "" : "text-foreground",
        )}
        style={accent ? { color: "var(--brand)" } : undefined}
      >
        {value}
      </div>
      {hint && (
        <div className="text-xs text-muted-foreground mt-2">{hint}</div>
      )}
    </button>
  );
}
